import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import {
  Suspense, useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationAlerts } from 'Types/CompaniesTypes';
import { Filter } from 'Types/FilterTypes';
import { getEmail, MidWidthApp1200 } from 'Utils/UtilityFunctions';
import { Spin } from 'antd';
import ArticleTileSkeleton from 'Components/common/skeleton/ArticleTileSkeleton';
import NoDataFound from 'Components/common/components/NoDataFound';
import {
  boxShadow,
  maxMobile,
  maxTablet, maxWidth, primaryHeadingColor, retina, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { TOOLTIP_HIGHLIGHTS } from 'Utils/Constants';
import { actions as alertActions } from '../../../Slice/AlertsSlice';
import {
  selectFeedNotificationLoading,
  selectFeedPeopleNotification,
  selectFeedPeopleMessage,
  selectFeedNotificationPage,
  selectFeedNotificationsEnded,
} from '../../../Selector/AlertsSelector';
import NotificationItem from '../../alerts/components/NotificationItem';

const Wrapper = styled.div`
height: 670px;
@media all and (max-width: ${maxMobile}) {
  height: 500px;
}
 display: flex;
 flex-direction: column;
 justify-content: space-between;
 box-shadow : ${boxShadow};
 background-color: #fff;
 border-radius: 12px;
 .articles-wrapper {
  height: calc(100% - 50px) !important;
  margin: 20px 24px 0px 24px;
  padding-right: 6px;
  @media all and (min-width: 1680px) {
    height: calc(100% - 60px) !important;
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    height: calc(-50px + 100%) !important;
    margin: 20px 24px 0px 24px;
  }
  @media all and (max-width: ${maxTablet}) {
    height: calc(-50px + 100%) !important;
    margin: 20px 10px 0px 10px;
  }
  @media all and (max-width: ${maxMobile}) {
    height: calc(-50px + 100%) !important;
    margin: 20px 10px 0px 10px;
  }
 }
 .inner-wrapper {
   height: 100%;
   display: flex;
   flex-direction: column;
   padding: 16px 0px 8px;
  .infinite-scroll-component__outerdiv {
    height: 100%;
  }
 }
 .heading {
  font-size: 28px;
  font-family: ${secondaryFont};
  font-weight: ${wMBold};
  color: ${primaryHeadingColor};
  padding: 0 24px;
  @media all and (max-width: ${maxWidth}), ${retina}{
    font-size: 20px;
  }
  @media all and (max-width: ${maxTablet}) {
    font-size: 15px;
    padding: 0 10px;
  }
}
`;

const Highlights = function Highlights() {
  const dispatch = useDispatch();
  const isDesktop1200 = MidWidthApp1200();
  const notificationLoading: boolean = useSelector(selectFeedNotificationLoading);
  const peopleNotification: NotificationAlerts[] = useSelector(selectFeedPeopleNotification);
  const message: string = useSelector(selectFeedPeopleMessage);
  const notificationPage: number = useSelector(selectFeedNotificationPage);
  const notificationEnded: boolean = useSelector(selectFeedNotificationsEnded);
  const peopleFil = [
    {
      filterId: '912',
      filterName: 'Shared Buyer Group',
      filterColor: 'null',
      subFilterId: 'None',
      filterTypeName: 'peopleNotification',
      isSelected: true,
    },
    {
      filterId: '913',
      filterName: 'People Role Update',
      filterColor: 'null',
      subFilterId: 'None',
      filterTypeName: 'peopleNotification',
      isSelected: true,
    },
  ];
  const highlightsListing = () => {
    const data: { username: string, page: number, filter: Filter[] } = {
      username: getEmail() || '',
      page: 1,
      filter: peopleFil,
    };
    dispatch(alertActions.getFeedNotificationAlerts(data));
  };
  useEffect(() => {
    highlightsListing();
  }, []);
  const fetchMoreNotifications = () => {
    const data = {
      username: getEmail() || '',
      page: notificationPage,
      filter: peopleFil,
    };
    dispatch(alertActions.getFeedNotificationAlerts(data));
  };
  return (
    <Wrapper>
      <div className="inner-wrapper">
        <span className="heading d-flex align-items-center">
          Highlights
          <span>
            <HeadingWithToolTip
              heightIconXSm="17px"
              toolTipText={TOOLTIP_HIGHLIGHTS}
              toolPlacement={`${isDesktop1200 ? 'bottomLeft' : 'bottomRight'}`}
            />
          </span>
        </span>
        <InfiniteScroll
          dataLength={peopleNotification.length}
          next={fetchMoreNotifications}
          hasMore={!notificationEnded}
          loader={<span className="spin-wrap"><Spin /></span>}
          className="o-x-hidden articles-wrapper"
          height="auto"
        >
          {peopleNotification?.length ? peopleNotification?.map(
            (notification: NotificationAlerts) => (
              <Suspense
                fallback={
                  <div />
                }
              >
                <NotificationItem
                  key={notification?.personId}
                  isRead={notification?.readFlag}
                  notification={notification}
                  closeDrawer={() => { }}
                />
              </Suspense>
            ),
          ) : null}
          {notificationLoading && [1, 2, 3, 4, 5, 6].map(() => (
            <Suspense
              fallback={
                <div />
              }
            >
              <ArticleTileSkeleton />
            </Suspense>
          ))}
          {
            !notificationLoading
            && peopleNotification.length < 1 && notificationEnded && (
              <Suspense
                fallback={
                  <div />
                }
              >
                <div className="no-test-message">
                  <NoDataFound title={message} />
                </div>
              </Suspense>
            )
          }
        </InfiniteScroll>
      </div>
    </Wrapper>
  );
};

export default Highlights;